module.exports = __webpack_public_path__ + "static/media/nMoneyTransferIcon.8d1e5e51.svg";